module.exports = "pegasus/assets/theme5/medium/8.jpg";